jQuery(function ($) {
	if ($('.faq-ctn').length === 0) {
		return;
	}

	$('.faq-single > span').on('click', function () {
		const $span = $(this);
		const $faqSingle = $span.closest('.faq-single');
		const $content = $span.siblings('.faq-content');
		const isActive = $span.hasClass('active');

		if (isActive) {
			$content.slideUp({
				duration: 300,
				easing: 'swing',
				complete() {
					$span.removeClass('active');
					$faqSingle.removeClass('active');
				},
			});
			return;
		}

		$('.faq-single > span').not($span).each(function () {
			const $otherSpan = $(this);
			const $otherFaqSingle = $otherSpan.closest('.faq-single');
			const $otherContent = $otherSpan.siblings('.faq-content');

			if ($otherSpan.hasClass('active')) {
				$otherContent.slideUp({
					duration: 300,
					easing: 'swing',
					complete() {
						$otherSpan.removeClass('active');
						$otherFaqSingle.removeClass('active');
					},
				});
			}
		});

		$faqSingle.addClass('active');
		$span.addClass('active');
		$content.slideDown({
			duration: 300,
			easing: 'swing',
		});
	});
});
